module.exports = __webpack_public_path__ + "static/img/ftmap.404d6ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ftmap.png
// module id = +pPj
// module chunks = 0